/**
 * "CLI environment variables & exit codes" — CLI section (ADR-0074).
 * Reconciled from packages/cli/src (api-client env resolution, i18n locale
 * resolution, dev config, lib/exit-codes).
 */
import type { DocPageContent } from '../types';

export const CLI_REFERENCE_PAGE: DocPageContent = {
  slug: 'cli/reference',
  titleKey: 'docs.cli.reference.title',
  descriptionKey: 'docs.cli.reference.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.cli.reference.lead' },

    { kind: 'heading', level: 2, id: 'env', textKey: 'docs.cli.reference.env.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.cli.reference.env.item.apiKey',
        'docs.cli.reference.env.item.apiUrl',
        'docs.cli.reference.env.item.dashboard',
        'docs.cli.reference.env.item.llmKeys',
        'docs.cli.reference.env.item.zdr',
        'docs.cli.reference.env.item.locale',
        'docs.cli.reference.env.item.telemetry',
        'docs.cli.reference.env.item.dev',
      ],
    },

    { kind: 'heading', level: 2, id: 'exit-codes', textKey: 'docs.cli.reference.exit.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.cli.reference.exit.item.ok',
        'docs.cli.reference.exit.item.user',
        'docs.cli.reference.exit.item.system',
        'docs.cli.reference.exit.item.usage',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'troubleshooting',
      textKey: 'docs.cli.reference.trouble.heading',
    },
    { kind: 'paragraph', textKey: 'docs.cli.reference.trouble.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.cli.reference.next.config.title',
          textKey: 'docs.cli.reference.next.config.text',
          to: { docSlug: 'cli/config' },
        },
        {
          titleKey: 'docs.cli.reference.next.frameworks.title',
          textKey: 'docs.cli.reference.next.frameworks.text',
          to: { docSlug: 'cli/frameworks' },
        },
      ],
    },
  ],
};
